import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NOTIFICATION_KEYWORDS } from 'src/app/constants';
import { BuyerTenderModel } from 'src/app/pages/buyer/models/buyer-tender.model';
import { BuyerTenderService } from 'src/app/pages/buyer/services/buyer-tender.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
	selector: 'app-allow-edit-quotation',
	templateUrl: './allow-edit-quotation.component.html',
	styleUrls: ['./allow-edit-quotation.component.scss']
})
export class AllowEditQuotationComponent implements OnInit {

	@Input() tenderData;
	currentLanguage;

	constructor(
		private modal: NzModalService,
		private translateService: TranslateService,
		private tenderService: BuyerTenderService<BuyerTenderModel>,
		private notificationService: NotificationService,
	) {
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe((response) => {
			if (response) {
				this.currentLanguage = response.lang;
			}
		});
	}

	ngOnInit(): void {
	}

	showAllowEditQuotation(allowEditQuotation): void {
		const payloadData = new FormData();
		const updatedData = {
			allowEditQuotation
		};
		payloadData.append('data', JSON.stringify(updatedData));

		const allowEditQuotationModalText = (!allowEditQuotation) ? 'tender_allow_edit_quotation_confirmation' : 'tender_decline_edit_quotation_confirmation';

		this.modal.confirm({
			nzTitle: this.translateService.instant(`global.common.${allowEditQuotationModalText}`),
			nzOkText: this.translateService.instant('global.common.update'),
			nzOkType: 'primary',
			nzOkDanger: true,

			nzOnOk: () => new Promise((resolve, reject) => {
				this.tenderService.updateTender(this.tenderData.id, payloadData).subscribe(
					(response) => {
						if (response.message) {
							this.notificationService.successNotification(
								NOTIFICATION_KEYWORDS.TENDER_UPDATED
							);
						}

						this.tenderService.getTender(this.tenderData.id);
						resolve(true);
					},
					(error) => {
						console.error(error);
						reject(false);
					}
				);
			}).catch((e) => console.error("ConfirmationModalError: ", e)),
			nzCancelText: this.translateService.instant('global.common.cancel'),
		});
	}
}
